import OrdersTable from "../components/orders-table";

function OrdersPage() {
  return (
    <div className="p-6 w-full mx-auto">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Orders</h1>
          <p className="text-muted-foreground mt-1">
            Manage and track your service orders
          </p>
        </div>

        {/* <Link to="/app/add-order">
          <Button
            variant="default"
            className="flex items-center gap-2"
          >
            <Plus className="h-5 w-5" />
            Add Order
          </Button>
        </Link> */}
      </div>

      <div className="">
        <OrdersTable />
      </div>
    </div>
  );
}

export default OrdersPage;
